import Header from "./Components/TermsOfService/Header"
import Content from "./Components/TermsOfService/Content"
import CTA from "./Components/CTA"
const TermsOfService = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <Content></Content>
            <CTA></CTA>
        </div>
    )
}

export default TermsOfService